import React, {useState} from 'react'
import {toAbsoluteUrl} from '_metronic/helpers'
import {ModalBox} from '../modals/ModalBox'
interface IFormUploadProps {
  name: string
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  disabled?: boolean
  url?: string
  onChange?: (val: any) => void
}

export const FormUpload: React.FC<IFormUploadProps> = (props) => {
  const [tempFile, setTempFile] = useState<any | null>(null)
  const [viewImg, setViewImg] = useState<{isShow: boolean; src: string}>({
    isShow: false,
    src: '',
  })
  const handleViewImg = (src: string) => {    
    setViewImg({
      isShow: true,
      src: src,
    })
  }
  const src = tempFile ? tempFile : `${props.url}/${props.field.value}`
  return (
    <>
      <div>
        <div
          className='image-input image-input-outline'
          data-kt-image-input='true'
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
          }}
        >
          <div
            onClick={() => handleViewImg(src)}
            className='image-input-wrapper w-125px h-125px cursor-pointer'
            style={{
              backgroundImage: `url(${toAbsoluteUrl(src)})`,
            }}
          ></div>
        </div>
      </div>
      <input
        className={props.className}
        type='file'
        name={props.field.name}
        // value={props.field.value}
        onChange={(val: any) => {
          if (val) {
            const objectUrl = URL.createObjectURL(val.currentTarget.files[0])
            setTempFile(objectUrl)
            props.form.setFieldValue(props.field.name, val.target.value)
            props.onChange?.(val)
          }
        }}
      />
      {viewImg.isShow && (
        <ModalBox
          title={'Preview'}
          stateShow={viewImg.isShow}
          onHide={() => setViewImg({...viewImg, isShow: false})}
          showOK={false}
          //onConfirmClick={()=>setViewImg({...viewImg, isShow: false})}
          txtCancel='Close'
          showCancel={true}
        >
          <div className='d-flex justify-content-center'>
            <img src={viewImg.src} alt=''></img>
          </div>
        </ModalBox>
      )}
    </>
  )
}
